/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

/**
 * Methods to help with ARIA support in interactions
 */

/**
 * Gets readable text content from content (e.g. in preparation for it to be announced)
 * Also strips placeholders and HTML tags from content
 * @see https://stackoverflow.com/a/47140708
 * @param {String} content
 * @returns {String} cleaned text content
 */
export function getReadableContent(content = '') {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    return (doc.body.textContent || '').replace(/\{\{.*?\}\}/g, '').trim();
}

/**
 * To allow to announce same text multiple times, insert empty character before text
 * @param {HTMLElement} ariaLiveElement
 * @param {String} text - new announcement text for this element
 * @returns {String} adjusted text
 */
export function textWithChangeToggle(ariaLiveElement, text) {
    if (ariaLiveElement && !ariaLiveElement.textContent.startsWith('\u00A0')) {
        return `${'\u00A0'}${text}`;
    }
    return text;
}
